import { useState, useEffect } from 'react';

export const useNavigation = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [activeDropdownItem, setActiveDropdownItem] = useState(null);

  useEffect(() => {
    const handleResize = () => {
      // Changed to 900px due to 7 nav items causing cramping
      const mobile = window.innerWidth <= 900;
      setIsMobile(mobile);
      
      // Close mobile menu when switching to desktop
      if (!mobile && isOpen) {
        setIsOpen(false);
      }
      
      // Close dropdown when switching to mobile
      if (mobile && dropdownVisible) {
        setDropdownVisible(false);
      }
    };

    // Initial check
    handleResize();
    
    // Add event listener
    window.addEventListener('resize', handleResize);
    
    // Cleanup
    return () => window.removeEventListener('resize', handleResize);
  }, [isOpen, dropdownVisible]);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const toggleDropdown = () => {
    setDropdownVisible(!dropdownVisible);
  };

  const closeDropdown = () => {
    setDropdownVisible(false);
  };

  const handleDropdownItemClick = (index, sectionId) => {
    setActiveDropdownItem(index);
    setDropdownVisible(false);

    // Scroll to the specific section using the section ID
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  const closeMobileMenu = () => {
    setIsOpen(false);
  };

  return {
    isMobile,
    isOpen,
    dropdownVisible,
    activeDropdownItem,
    toggleMenu,
    toggleDropdown,
    closeDropdown,
    handleDropdownItemClick,
    closeMobileMenu
  };
};